import { Fetch } from 'lib';

type RequestResponses = {};

type RequestParameters = {
  id: string;
};

const deleteDiscountCode = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminDiscountCode/deleteDiscountCode',
    method: 'DELETE',
    params,
  });

export { deleteDiscountCode };
